/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CallMeDto } from '../models/CallMeDto';
import type { CreateSubscriberDto } from '../models/CreateSubscriberDto';
import type { ManageMunicipalitySubscriberDto } from '../models/ManageMunicipalitySubscriberDto';
import type { Object } from '../models/Object';
import type { UpdateSubscriberContactDto } from '../models/UpdateSubscriberContactDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SubscriberService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @param requestBody
     * @returns string
     * @throws ApiError
     */
    public manageForMunicipality(
        requestBody: ManageMunicipalitySubscriberDto,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/subscriber/municipality',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public getMunicipalityResult(
        id: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/subscriber/municipality/result/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public create(
        requestBody: CreateSubscriberDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/subscriber',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public callMe(
        requestBody: CallMeDto,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/subscriber/call-me',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public getCalls(): CancelablePromise<Array<Record<string, any>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/subscriber/list/calls',
        });
    }

    /**
     * @param q
     * @param cognitiveIssues
     * @param remindInYear
     * @param minRiskScore
     * @param maxRiskScore
     * @param hasUser
     * @param wantsToBeContacted
     * @param page
     * @param limit
     * @param sortBy
     * @param sortOrder
     * @param language
     * @param municipality
     * @returns any
     * @throws ApiError
     */
    public findAll(
        q?: string,
        cognitiveIssues?: boolean,
        remindInYear?: boolean,
        minRiskScore?: number,
        maxRiskScore?: number,
        hasUser?: boolean,
        wantsToBeContacted?: Object,
        page: number = 1,
        limit: number = 20,
        sortBy: string = 'createdAt',
        sortOrder?: Object,
        language?: string,
        municipality?: Object,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/subscriber/list',
            query: {
                'q': q,
                'cognitiveIssues': cognitiveIssues,
                'remindInYear': remindInYear,
                'minRiskScore': minRiskScore,
                'maxRiskScore': maxRiskScore,
                'hasUser': hasUser,
                'wantsToBeContacted': wantsToBeContacted,
                'page': page,
                'limit': limit,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
                'language': language,
                'municipality': municipality,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public updateContact(
        id: string,
        requestBody: UpdateSubscriberContactDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/subscriber/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public contactMe(
        id: string,
        requestBody: UpdateSubscriberContactDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/subscriber/{id}/contact-me',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public remindMe(
        id: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/subscriber/{id}/remind-me',
            path: {
                'id': id,
            },
        });
    }

}
